import { render, staticRenderFns } from "./ProgramDetailAdmin.vue?vue&type=template&id=7158bcc1&"
import script from "./ProgramDetailAdmin.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports